import styled from 'styled-components';
import logo from '../../../assets/images/logo.png';

export const Container = styled.div`
  width: 100%;
  padding:0 10%;
  height:600px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  background-image: url(${logo});
  background-size: 45%;
  background-repeat: no-repeat;
  background-position: center;
  background-position-x: 90%;

  box-sizing:border-box;

  @media only screen and (max-width: 1000px) {
    background-size: 25%;
  }

  @media only screen and (max-width: 600px) {
    background-position-x: center;
    background-position-y: 5px;
    padding: 0;
    justify-content: center;
  }

  form {
    box-sizing: border-box;
    width: 300px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    background: #fff;

    -webkit-box-shadow: 0px 0px 5px 0.5px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 0px 5px 0.5px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 5px 0.5px rgba(0, 0, 0, 0.3);

    .MuiFormControl-root{
      margin-top:15px;
    }
    .MuiButtonBase-root {
        background: #fff;
    }

    .MuiFormLabel-root.Mui-focused{
        color:#000;
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{
      border-color: #000;
    }

    >div {
      text-align: center;
    }

    >button {
      height: 36px;
      margin-top:20px;
      border: 0;
      border-radius: 8px;
      background: #ccc;

      &:hover {
        background: #bababa;
      }
    }

    >span{
      color: #EF1231;
      font-size:12px;
      text-align: initial;
    }
  }

  img {
    width: 40%;
    height: 30%;
  }
`;
